export default __webpack_public_path__ + "static/gallery-award-big-a-0b17f6da782ca1a968862401e4f1e316.jpg";